import { Component, OnInit } from '@angular/core';
import { ActivatedRoute}  from '@angular/router';

///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard-guia/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { WizardService } from 'app/main/wizard-n35/services/wizard.service';
import { Subject } from 'rxjs';
import *  as $ from 'jquery';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-guia1',
  templateUrl: './guia1.component.html',
  styleUrls: ['./guia1.component.scss']
})
export class Guia1Component implements OnInit {
  info = [
    {
      position: '113',
      title: 'WIZARD.GUIA1.title',
      subtitle: 'WIZARD.GUIA1.subtitle',
      content: 'WIZARD.GUIA1.content',
      content2: 'WIZARD.GUIA1.content2',
    }
  ]

  preguntas1 = [
    {
      position: '113',
      ques: 'WIZARD.GUIA1.SURVEY.QUES1',
      opc : [
        {
          ques: 'WIZARD.GUIA1.SURVEY.QUESTIONS1.ques1'
        },{
          ques: 'WIZARD.GUIA1.SURVEY.QUESTIONS1.ques2'
        },{
          ques: 'WIZARD.GUIA1.SURVEY.QUESTIONS1.ques3'
        },{
          ques: 'WIZARD.GUIA1.SURVEY.QUESTIONS1.ques4'
        },{
          ques : 'WIZARD.GUIA1.SURVEY.QUESTIONS1.ques5'
        },{
          ques: 'WIZARD.GUIA1.SURVEY.QUESTIONS1.ques6',
        },{
          ques: 'WIZARD.GUIA1.SURVEY.QUESTIONS1.ques7'
        }
      ]
    },{
      position: '113',
      ques : 'WIZARD.GUIA1.SURVEY.QUES2',
      opc : [
        {
          ques: 'WIZARD.GUIA1.SURVEY.QUESTIONS2.ques1',
        },{
          ques: 'WIZARD.GUIA1.SURVEY.QUESTIONS2.ques2',
        }
      ]
    },{
      position: '113',
      ques: 'WIZARD.GUIA1.SURVEY.QUES3',
      opc : [
        {
          ques: 'WIZARD.GUIA1.SURVEY.QUESTIONS3.ques1',
        },{
          ques: 'WIZARD.GUIA1.SURVEY.QUESTIONS3.ques2',
        },{
          ques: 'WIZARD.GUIA1.SURVEY.QUESTIONS3.ques3',
        },{
          ques: 'WIZARD.GUIA1.SURVEY.QUESTIONS3.ques4',
        },{
          ques: 'WIZARD.GUIA1.SURVEY.QUESTIONS3.ques5',
        },{
          ques: 'WIZARD.GUIA1.SURVEY.QUESTIONS3.ques6',
        },{
          ques: 'WIZARD.GUIA1.SURVEY.QUESTIONS3.ques7',
        }
      ]
    },{
      position: '113',
      ques: 'WIZARD.GUIA1.SURVEY.QUES4',
      opc : [
        {
          ques: 'WIZARD.GUIA1.SURVEY.QUESTIONS4.ques1',
        },{
          ques: 'WIZARD.GUIA1.SURVEY.QUESTIONS4.ques2',
        },{
          ques: 'WIZARD.GUIA1.SURVEY.QUESTIONS4.ques3',
        },{
          ques: 'WIZARD.GUIA1.SURVEY.QUESTIONS4.ques4',
        },{
          ques: 'WIZARD.GUIA1.SURVEY.QUESTIONS4.ques5',
        }
      ]

    },{

    }
    
  ]
  dataId : any ;
  private _unsubscribeAll: Subject<any>;
  constructor(
    private activated: ActivatedRoute,
    private wizardService: WizardService,
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
    ) {
    this._unsubscribeAll = new Subject();
    lang_wizard.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.translateSrv.onLangChange.subscribe(() => { this.cambiaIdiomaBanner(this.translateSrv.currentLang); });
  }
  ngOnInit() {
    this.cambiaIdiomaBanner(this.translateSrv.currentLang);
    $(window).scrollTop();
    this.activated.data.subscribe  (params=>{this.dataId = params});
  console.log(this.dataId);
  }

  idiomaBanner:any;
  cambiaIdiomaBanner(idioma:string){
    this.idiomaBanner = this.translateSrv.currentLang; 
    switch(idioma){
      case 'es': this.idiomaBanner = idioma; 
      break;
      default: this.idiomaBanner = 'en';
    }
    this.getBanner();
  }
  urlBanner:any;
  getBanner(){
    this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-12.png';
  }
}
